/* eslint-disable filename-rules/match */
import { lifecycleHooks, resolve } from "aurelia";
import { IDialogService } from "@aurelia/dialog";
import { I18N } from "@aurelia/i18n";
import { Parameters, RoutingInstruction } from "@aurelia/router";
import { IStore } from "@aurelia/state";

import { MtGenericDialog } from "@/components/modals/mt-generic-dialog";
import { DID_SHOW_WELCOME, LOGOUT } from "@/static/storeActions";
import { IState } from "@/store/state";

@lifecycleHooks()
export class AuthHook {
  private readonly store = resolve(IStore) as IStore<IState>;
  private readonly i18n = resolve(I18N);
  private readonly ds = resolve(IDialogService);

  canLoad(viewModel: unknown, params: Parameters, instruction: RoutingInstruction) {
    // If coming from login, allow
    const { isLoggedIn, loginTimestamp, didShowWelcome } = this.store.getState();
    if (isLoggedIn) {
      // Check if session expired
      const now = +new Date();
      // Has it been 10 hours since login?
      const didSessionExpire = now - 1000 * 60 * 60 * 10 > loginTimestamp;
      // if so, logout and stop navigation attempt
      if (didSessionExpire) {
        this.store.dispatch({ type: LOGOUT });
        return false;
      }
      // Show announcement dialog upon successful login
      if (!didShowWelcome)
        this.ds
          .open({
            component: () => MtGenericDialog,
            model: {
              title: "ANNOUNCEMENT",
              text: this.i18n.tr("dialog.open_beta"),
              buttons: [{ label: this.i18n.tr("button.proceed"), value: true }],
            },
          })
          .whenClosed(async (response) => {
            if (response.status === "ok" && response.value === true) {
              this.store.dispatch({ type: DID_SHOW_WELCOME });
            }
          });

      if (instruction.route.match.path === "login") return "";
      return true;
    }
    if (instruction.route.match.path === "login") return true;

    // Allow NDM without login for use with c-comm website.
    if (instruction.route.match.path === "ndm") return true;

    return "login";
  }

  loading(viewModel: unknown, params: Parameters, instruction: RoutingInstruction) {
    const header = [instruction.route.match.title];

    while (instruction.scope.routingInstruction) {
      header.unshift(instruction.scope.routingInstruction.route.match.title);
      instruction = instruction.scope.routingInstruction;
    }
    const routeText = header.join(" > ");
    const desktopLabel = document.querySelector("#routeLabel");
    const mobileLabel = document.querySelector("#routeLabel-mobile");
    if (desktopLabel) desktopLabel.innerHTML = routeText;
    if (mobileLabel) mobileLabel.innerHTML = routeText;
  }
}
